import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('confirm-fill-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.229 2.8c-11.599 0-21 9.401-21 21 0 11.598 9.401 21 21 21 11.597 0 21-9.402 21-21 0-11.599-9.401-21-21-21z",
    fill: props.colors[0]
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin,
    d: "M14.429 23.778L22.89 31 36.43 16"
  })));
});